import { useState } from "react";
import "../../styles/Dropdown.css";
import { usePopper } from "react-popper";
import ClickOutside from "./ClickOutside";

function Dropdown({
  target,
  menu,
  onOpen = () => {},
  onClose = () => {},
  placement,
  className = "",
  style = {},
}) {
  const [referenceElement, setReferenceElement] = useState(null);
  const [popperElement, setPopperElement] = useState(null);
  const [arrowElement, setArrowElement] = useState(null);
  const [showMenu, setShowMenu] = useState(false);

  const { styles, attributes } = usePopper(referenceElement, popperElement, {
    placement: placement || "bottom-end",
    modifiers: [{ name: "arrow", options: { element: arrowElement } }],
  });

  return (
    <>
      <div
        ref={setReferenceElement}
        onClick={() => {
          setShowMenu(true);
          onOpen();
        }}
        onFocus={() => {
          setShowMenu(true);
          onOpen();
        }}
        className={"hover-pointer " + className}
        style={showMenu ? { pointerEvents: "none" } : {}}
      >
        {target}
      </div>

      {showMenu && (
        <ClickOutside
          onClickOutside={() => {
            setShowMenu(false);
            onClose();
          }}
        >
          {(wrapperRef) => (
            <div
              ref={setPopperElement}
              style={{ ...styles.popper, ...style, zIndex: 5 }}
              {...attributes.popper}
            >
              <div className="dropdown-menu-wrapper" ref={wrapperRef}>
                {typeof menu === "function" ? menu({ setShowMenu }) : menu}
                <div ref={setArrowElement} style={styles.arrow} />
              </div>
            </div>
          )}
        </ClickOutside>
      )}
    </>
  );
}

export default Dropdown;
